var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.568 1.878L5.586 9.861a1 1 0 01-1.415 0L1.432 7.12",
    stroke: "#316F1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "32ff5a6107656b5cf428d944e07a9baa.svg";
export { SvgTick as ReactComponent };